module.exports = __webpack_public_path__ + "static/media/reviews.024fde38.svg";